import React from 'react';
import styled from 'styled-components';
import Paper from '@mui/material/Paper';

import { colors } from 'theme/colors';

export const ControlPaper = styled(Paper)`
  border-radius: 4px;
  border: 0.5px solid ${colors.legacy.grey[500]};
  margin: 12px 29px;
  display: flex;
`;

export const CommonPropsButtons = `
  color: ${colors.ui.chip.grayText};
  margin: 4px;

  opacity: 1;
  transition: 0.2s;
  :hover {
    opacity: 0.7;
  }
`;
